import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';


class AlertDialog extends Component {

  constructor(props){
    super(props);
    this.state = {
        open: true
    }
}

  handleClose = () => {
    this.props.close();
  };
 render () {
  return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose} >
        <DialogContent>
          <DialogContentText id="messageId">
            {this.props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary" autoFocus>Ok</Button>
        </DialogActions>
      </Dialog>
  );
 }
}


export default AlertDialog; 